// Общий кнопочный ряд для выравнивания/размера (реф: renderAlignmentSelector,
// renderTextSizeSelector в SubBlockSettingsEditor) — переиспользуется Heading/TextSettings.
// Данные ряда (ALIGN_OPTIONS, segmentedButtonClass) живут в ./segmented — файл с
// компонентом не должен экспортировать ничего кроме компонентов.
import { cn } from '@teach/ui'
import { segmentedButtonClass, type SegmentedOption } from './segmented'

interface Props<V extends string> {
  options: Array<SegmentedOption<V>>
  // `string`, а не `V`: вызывающие передают полный тип поля элемента
  // (например DesignTextAlign), который шире набора значений этого ряда.
  value: string
  onSelect: (value: V) => void
  dense?: boolean
}

export const SegmentedRow = <V extends string>({ options, value, onSelect, dense }: Props<V>) => (
  <div className="flex gap-1">
    {options.map(({ value: v, label, icon: Icon, title }) => (
      <button
        key={v}
        type="button"
        title={title}
        onClick={() => onSelect(v)}
        className={cn(
          'flex-1',
          dense ? 'px-2 py-1.5 text-sm font-medium' : 'p-2',
          segmentedButtonClass(value === v),
        )}
      >
        {Icon ? <Icon className="mx-auto h-4 w-4" /> : label}
      </button>
    ))}
  </div>
)
